// All money is stored and summed as integer kuruş. A restaurant rings up thousands
// of small additions per day, and float drift shows up in the day-end total as
// a missing kuruş. Conversion to/from lira happens only here.

export function formatKurus(kurus: number): string {
  const sign = kurus < 0 ? '-' : ''
  const abs = Math.abs(Math.round(kurus))
  const lira = Math.floor(abs / 100)
  const kr = abs % 100
  return `${sign}${lira.toLocaleString('tr-TR')},${String(kr).padStart(2, '0')}`
}

/** "1.234,50 ₺", for display in the UI and on the receipt. */
export function formatTRY(kurus: number): string {
  return `${formatKurus(kurus)} ₺`
}

/** Parses free-typed lira input ("12,5", "12.50", "12") into integer kuruş. */
export function liraToKurus(input: string | number): number | null {
  if (typeof input === 'number') {
    return Number.isFinite(input) ? Math.round(input * 100) : null
  }
  const cleaned = input.trim().replace(/\s/g, '').replace(',', '.')
  if (cleaned === '') return null
  const value = Number(cleaned)
  if (!Number.isFinite(value) || value < 0) return null
  return Math.round(value * 100)
}

/**
 * Applies a percentage discount and returns whole kuruş. The discount is
 * derived from the rounded charge rather than rounded on its own, so
 * charged + discount always adds back up to the original total, a report
 * that sums both columns has to reconcile exactly.
 */
export function applyDiscount(
  totalKurus: number,
  percent: number,
): { chargedKurus: number; discountKurus: number } {
  const pct = Math.min(100, Math.max(0, percent))
  const chargedKurus = Math.round((totalKurus * (100 - pct)) / 100)
  return { chargedKurus, discountKurus: totalKurus - chargedKurus }
}

/** Kuruş → editable lira string for form inputs ("15000" → "150"). */
export function kurusToLiraInput(kurus: number): string {
  const lira = kurus / 100
  return Number.isInteger(lira) ? String(lira) : lira.toFixed(2).replace('.', ',')
}

/**
 * Tutar kutusuna yazılanı süzer: yalnız rakam ve bir virgül, virgülden sonra
 * en fazla iki hane. Harf ve başka işaret yazılamıyor (kullanıcı, 5 Eki 2026).
 * Nokta binlik ayracı sayılıp atılıyor: "1.500" bin beş yüz olarak kalır.
 * `decimalDot` açıksa nokta virgüle dönüyor (indirim oranı gibi binliği
 * olmayan kutularda "12.5" yazan kişi için).
 */
export function amountInput(text: string, decimalDot = false): string {
  const t = decimalDot ? text.replace(/\./g, ',') : text
  const [whole, ...rest] = t.replace(/[^\d,]/g, '').split(',')
  return rest.length ? `${whole},${rest.join('').slice(0, 2)}` : whole
}
